import reusables from '@styles/theme/reusables';
export default {
  radioWrapper: {
    display: 'flex',
    flexWrap: 'nowrap',
    flexDirection: 'column'
  },
  radioContainer: {
    display: 'inline-flex'
  },
  hiddenRadio: {
    display: 'none'
  },
  radioLabel: {
    letterSpacing: '0',
    textAlign: 'left',
    cursor: 'pointer'
  },
  radioMarkContainer: (isChecked: boolean, showError: boolean) => {
    const borderColor = isChecked ? 'darkGrey700' : 'lightGrey700';
    return {
      borderWidth: '1px',
      borderColor: showError ? 'accent700' : borderColor,
      borderStyle: 'solid',
      borderRadius: '50%',
      mr: '8px',
      width: '20px',
      minWidth: '20px',
      cursor: 'pointer',
      height: '20px',
      minHeight: '20px',
      position: 'relative',
      ...reusables.mainTransition('borderColor'),
      '&:focus': {
        // outline: '2px solid blue500',
        // outlineOffset: '2px',
      },
      '&:after': {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '10px',
        height: '10px',
        content: '""',
        opacity: isChecked ? 1 : 0,
        background: isChecked ? 'darkGrey700' : 'transparent',
        borderRadius: '50%',
        ...reusables.mainTransition('opacity')
      }
    };
  },
  error: (showError: boolean) => ({
    width: '100%',
    color: 'accent700',
    fontFamily: 'uniform',
    fontWeight: 'normal',
    fontSize: 'caption',
    height: showError ? '25px' : 0,
    opacity: showError ? 1 : 0,
    visibility: showError ? 'visible' : 'hidden',
    ...reusables.mainTransition('opacity')
  })
};